import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-8" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-label" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }

import { ref, onMounted } from "vue";
import ToolServices from "@/projects/tenant/modules/tools/services/ToolServices";
import { InfoFilled } from "@element-plus/icons-vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'EquityIndex',
  setup(__props) {

const isLoading = ref(false);
const detail = ref(Array<any>());

const fetchData = async () => {
  isLoading.value = true;
  try {
    const data = await ToolServices.getEquityBelowCredit();
    detail.value = data;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

const sendEmail = async (item) => {
  isLoading.value = true;
  let data = {
    to: item.email,
    title: "",
    language: "",
  };
  try {
    const data = await ToolServices.sendEquityBelowCreditEmail(data);
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("title.equityBelowCredit")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("title.login")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.group")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.credit")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.equity")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.balance")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.difference")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.lastUpdateTime")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
          ])
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
              _createVNode(_component_LoadingRing)
            ]))
          : (!isLoading.value && detail.value.length == 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                _createVNode(_component_NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(item.login), 1),
                    _createElementVNode("td", null, _toDisplayString(item.group), 1),
                    _createElementVNode("td", null, _toDisplayString(item.credit), 1),
                    _createElementVNode("td", null, _toDisplayString(item.equity), 1),
                    _createElementVNode("td", null, _toDisplayString(item.balance), 1),
                    _createElementVNode("td", null, _toDisplayString(item.difference), 1),
                    _createElementVNode("td", null, _toDisplayString(item.lastUpdateTime), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_el_popconfirm, {
                        "confirm-button-text": "Yes",
                        "cancel-button-text": "No",
                        icon: _unref(InfoFilled),
                        "icon-color": "#626AEF",
                        title: "Are you sure to send email?",
                        onConfirm: ($event: any) => (sendEmail(item))
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_button, { type: "success" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("action.sendEmail")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["icon", "onConfirm"])
                    ])
                  ]))
                }), 128))
              ]))
      ])
    ])
  ]))
}
}

})